import * as Sentry from '@sentry/react';

Sentry.init({
	dsn: 'https://7abce2edc33c8bda802bec8e6cee737d@o4511105814822912.ingest.de.sentry.io/4511105848770640',
	environment: __DEV__ ? 'development' : 'production',
	tracesSampleRate: 0.1,
	// Don't send events in development
	enabled: !__DEV__,
});

export { Sentry };
